import { render, staticRenderFns } from "./ExpressList.vue?vue&type=template&id=b6e13172&scoped=true"
import script from "./ExpressList.vue?vue&type=script&lang=js"
export * from "./ExpressList.vue?vue&type=script&lang=js"
import style0 from "./ExpressList.vue?vue&type=style&index=0&id=b6e13172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e13172",
  null
  
)

export default component.exports